<template>
  <div class="w-100">
    <b-skeleton-wrapper :loading="isLoading">
      <template #loading>
        <div class="d-flex justify-content-center">
          <div class="d-flex justify-content-start overflow-x-auto hide-scroll w-100" :class="`justify-content-${itemsAlign}`">
            <div class="mr-4" v-for="i in 3">
              <b-skeleton class="mx-auto mb-2" width="40px" height="40px"></b-skeleton>
              <b-skeleton width="70px" height="20px"></b-skeleton>
            </div>
          </div>
        </div>
      </template>
      <template #default>
        <div v-if="additionalModuleIsValid" class="d-flex justify-content-center">
          <div class="d-flex justify-content-start overflow-x-auto hide-scroll w-100" :class="`justify-content-${itemsAlign}`">
            <div 
              class="cursor-pointer flex-shrink-0 product-tab-item" 
              v-for="(tab,tabIndex) in tabList" 
              @mouseenter="activateHoveringItem(tabIndex, true)"
              @mouseleave="activateHoveringItem(tabIndex, false)"
              @click="selectTab(tab)">
              <div 
                class="pb-1 border-b-bold mr-4 mr-lg-5 delay" 
                :class="selectedTab.id === tab.id || tab.isHovering ? 'border-color-green' : 'border-color-transparent'">
                <div v-if="tab.image_url" class="mb-2-5 d-flex justify-content-center align-items-end w-100">
                  <img :src="tab.image_url" height="26" />
                </div>
                <HotelProductTabIcon v-else :module="tab.module" :is-active="selectedTab.id === tab.id || tab.isHovering" />            
                <p 
                  class="mb-0 ls-0-4 text-uppercase text-14 delay" 
                  :class="selectedTab.id === tab.id || tab.isHovering ? 'text-green font-extrabold' : 'text-subcolor font-bold'"
                  >{{ tab.name }}</p>
              </div>
            </div>
          </div>
        </div>
      </template>
    </b-skeleton-wrapper>
  </div>
</template>

<script>
  import { mapGetters, mapMutations } from 'vuex';
  import {get} from '@/services/index.js';
  import HotelProductTabIcon from './HotelProductTabIcon.vue';

  export default {
    props: {
      itemsAlign:{
        type: String,
        default: 'start'
      }
    },
    components:{
      HotelProductTabIcon
    },
    data(){
      return{
        isLoading: true,
        tabList: [],
        selectedTab: {},
        additionalModuleIsValid: true 
      }
    },
    computed:{
      ...mapGetters(['getMerchant', 'getActiveHotelModule']),
    },
    methods:{
      ...mapMutations(['setActiveHotelModule', 'setShowAdditionalModuleInSearch']),
      async getCategoryList(){
        try {
          this.isLoading = true
          const apiParams = { merchant_id: this.getMerchant.id }
          const apiResponse = await get("CORE_HOTEL", "hotel-additional-service-category", apiParams);
          
          const { success, data = null, message = "" } = apiResponse.data;
          if(!success) throw new Error(message);
          if(data.length == 0){
            this.additionalModuleIsValid = false
            this.setShowAdditionalModuleInSearch(false)
          } else{
            this.assignTabList(data)
            this.setShowAdditionalModuleInSearch(true)
          };
        } catch (error) {
          const errorMsg = error.message || "An unexpected error occurred";
          console.log("ERROR Additional getCategoryList :", errorMsg)
        } finally {
          this.isLoading = false
        }
      },
      assignTabList(otherTab){
        this.tabList = [{ id: 'room', name: 'Room', module: 'ROOM' }]
        const productCategories = this.parsingDetailModule(otherTab);
        this.tabList.push(...productCategories)
        if (this.$isEmpty(this.getActiveHotelModule)) this.selectTab(this.tabList[0])
        else this.selectTab(this.getActiveHotelModule)
      },
      parsingDetailModule(categoryList){
        return categoryList.map(category=>{
          category.total_additional_service = 0;

          const isModuleActivity = this.$isNotEmpty(category.merchant_pos) &&  (category.merchant_pos.pos_type == 'SPA' || category.merchant_pos.pos_type == 'ACTIVITY')

          category.total_product_display = this.$isNotEmpty(category.merchant_pos) && (isModuleActivity || category.merchant_pos.pos_type == 'VOUCHER') ? 2 : 6

          if(category.merchant_pos == null) category.page_module = 'ORIGINAL'
          else if(isModuleActivity) category.page_module = 'ACTIVITY'
          else category.page_module = category.merchant_pos.pos_type

          if(category.merchant_pos == null){
            category.module = 'OTHER'
            category.title = category.name
            category.subtitle = category.description
          } else {
            category.module = category.merchant_pos.pos_type
            category.title = category.merchant_pos.tagline
            category.subtitle = category.merchant_pos.sub_tagline
          }

          category.isHovering = false;
          
          return category;
        })
      },
      selectTab(tab){
        const copyTab = this.$deepCopy(tab);
        this.selectedTab = copyTab
        this.setActiveHotelModule(copyTab)
      },
      activateHoveringItem(index, hover){
        this.tabList[index].isHovering = hover;
      }
    },
    mounted(){
      this.getCategoryList()
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/hotel/HotelProductTab.vue